<template>
  <div class="vehicles">
    <page-header
      title="Fleets"
      breadcrumb="Dashboard > Settings  > Fleets"
    />
    <vehicles-data-table/>
  </div>
</template>

<script>
import VehiclesDataTable from "./partials/VehiclesDataTable";
import PageHeader from "@/components/UI/NewPageHeader";
export default {
  components: {
    VehiclesDataTable,
    PageHeader
  },
};
</script>

<style></style>
